import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { allManga } from '@/mocks/manga';

export default function AboutPage() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '178漫画网',
    url: 'http://91cghlw.cn/',
    description: '178漫画网是一个专注于免费漫画阅读的在线平台，提供丰富多样的漫画资源，涵盖校园恋爱、热血运动、日常搞笑等多种分类。',
    foundingDate: '2020',
    logo: 'http://91cghlw.cn/logo.png',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@91cghlw.cn',
      telephone: '+86-10-8888-6666',
      availableLanguage: ['Chinese'],
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '望京科技园B座1206',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
    sameAs: [
      'http://91cghlw.cn/',
      'http://91cghlw.cn/178manhua',
    ],
  };

  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 178漫画网',
    description: '了解178漫画网——专业的免费漫画阅读平台，致力于为漫迷提供流畅、免费、丰富的漫画阅读体验。',
    url: 'http://91cghlw.cn/about',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '178漫画网',
      url: 'http://91cghlw.cn/',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '178漫画网是如何创立的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '178漫画网创立于2020年，由一群热爱漫画的年轻人共同打造。我们致力于构建一个免费、纯净、用户体验至上的漫画阅读平台，让每一位漫迷都能在这里找到属于自己的精神角落。',
        },
      },
      {
        '@type': 'Question',
        name: '178漫画网的内容来源是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '178漫画网与国内外多家漫画工作室和出版社建立了合作关系，所有内容均获得正版授权。我们严格遵循版权法规，致力于推动漫画产业的健康发展。',
        },
      },
      {
        '@type': 'Question',
        name: '如何与178漫画网进行商务合作？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '欢迎漫画作者、工作室、出版社及品牌方与我们联系。商务合作请发送邮件至 hello@91cghlw.cn，我们的商务团队会在3个工作日内与您取得联系。',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <Breadcrumb items={breadcrumbItems} />

          {/* About Hero */}
          <section className="py-14 md:py-24 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
                  <div className="w-full lg:w-1/2">
                    <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-900 leading-tight">
                      关于
                      <br />
                      178漫画网
                    </h1>
                    <div className="mt-8 grid grid-cols-3 divide-x divide-background-300">
                      <div className="pr-6">
                        <p className="text-3xl md:text-4xl font-heading text-accent-500">10万+</p>
                        <p className="mt-1 text-xs text-foreground-500">日活跃用户</p>
                      </div>
                      <div className="px-6">
                        <p className="text-3xl md:text-4xl font-heading text-accent-500">
                          {allManga.length * 100}+
                        </p>
                        <p className="mt-1 text-xs text-foreground-500">漫画作品</p>
                      </div>
                      <div className="pl-6">
                        <p className="text-3xl md:text-4xl font-heading text-accent-500">500万+</p>
                        <p className="mt-1 text-xs text-foreground-500">月阅读量</p>
                      </div>
                    </div>
                    <p className="mt-8 text-sm text-foreground-600 leading-relaxed max-w-lg">
                      178漫画网创立于2020年，由一群热爱漫画的年轻人共同打造。我们致力于构建一个免费、纯净、用户体验至上的漫画阅读平台，让每一位漫迷都能在这里找到属于自己的精神角落。经过六年发展，已经成为国内领先的免费漫画阅读平台之一。
                    </p>
                  </div>
                  <div className="w-full lg:w-1/2">
                    <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-accent-100/50 via-secondary-100/30 to-primary-100/50 p-8 md:p-12">
                      <div className="flex flex-wrap gap-4">
                        <div className="w-24 h-24 rounded-2xl bg-accent-200/60"></div>
                        <div className="w-32 h-20 rounded-full bg-secondary-200/50 mt-4"></div>
                        <div className="w-20 h-28 rounded-2xl bg-primary-200/60 -mt-2"></div>
                        <div className="w-28 h-24 rounded-full bg-accent-100/70"></div>
                        <div className="w-16 h-16 rounded-2xl bg-secondary-300/40"></div>
                        <div className="w-20 h-20 rounded-full bg-primary-300/30"></div>
                      </div>
                      <div className="absolute bottom-8 right-8 text-right">
                        <p className="text-6xl font-heading text-accent-400/60">2020</p>
                        <p className="text-xs text-foreground-500 mt-1">始于热爱</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Brand Story & Platform Info */}
          <section className="py-14 md:py-20 bg-background-100">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 gap-4">
                  <div className="lg:w-1/3">
                    <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 leading-tight">
                      了解我们
                    </h2>
                  </div>
                  <div className="lg:w-2/3">
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      从一个小众漫画爱好者社区起步，178漫画网始终坚持「免费阅读、优质体验」的初心，逐步成长为覆盖全品类的综合性漫画阅读平台。
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                  {/* Brand Story */}
                  <div className="lg:col-span-1 lg:row-span-2 bg-foreground-900 rounded-2xl p-8 flex flex-col justify-between relative overflow-hidden">
                    <div className="absolute inset-0 opacity-10">
                      <img
                        src="https://readdy.ai/api/search-image?query=Abstract%20watercolor%20texture%20in%20warm%20coral%20and%20teal%20tones%2C%20soft%20gradient%2C%20minimal%20artistic%20style%2C%20dreamy%20atmosphere&width=500&height=600&seq=about-brand-bg&orientation=portrait"
                        alt=""
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="relative z-10">
                      <span className="px-3 py-1 bg-accent-500 text-white text-xs rounded-full whitespace-nowrap">
                        品牌故事
                      </span>
                      <h3 className="text-2xl font-bold text-white mt-4">始于热爱，忠于初心</h3>
                      <p className="text-sm text-white/70 mt-3 leading-relaxed">
                        178漫画网诞生于2020年夏天的北京，三位热爱漫画的年轻人租下了一间20平米的小办公室，开始了他们的创业之旅。最初的网站只有不到100部漫画，每天只有几百位读者访问。但我们坚信，好的内容值得被更多人看到，好的阅读体验不应该被付费墙所阻隔。
                      </p>
                      <p className="text-sm text-white/70 mt-3 leading-relaxed">
                        六年过去了，我们从那个小办公室搬到了望京科技园，团队也从3人扩展到了50余人。不变的是那份对漫画的热爱，以及对用户的承诺——永远免费，永远纯粹。
                      </p>
                    </div>
                    <div className="relative z-10 mt-6">
                      <div className="w-16 h-16 rounded-xl overflow-hidden">
                        <img
                          src="https://readdy.ai/api/search-image?query=Young%20creative%20team%20working%20together%20in%20modern%20office%2C%20manga%20posters%20on%20wall%2C%20casual%20startup%20vibe%2C%20warm%20lighting%2C%20editorial%20photography&width=160&height=160&seq=about-team&orientation=squarish"
                          alt="178漫画网 团队"
                          title="178漫画网 创始团队"
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Business Cooperation */}
                  <div className="bg-background-50 rounded-2xl p-6">
                    <div className="flex items-start gap-3 mb-4">
                      <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-service-line text-lg text-secondary-600"></i>
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-foreground-800">商务合作</h3>
                        <p className="text-xs text-foreground-400 mt-1">Business Cooperation</p>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      欢迎漫画作者、工作室、出版社及品牌方与我们联系。178漫画网提供多种合作模式，包括内容授权、广告投放、品牌联名等，共同探索漫画产业的无限可能。
                    </p>
                    <div className="mt-4 pt-4 border-t border-background-200">
                      <p className="text-xs text-foreground-500">
                        <strong className="text-foreground-700">商务邮箱：</strong>
                        <a href="mailto:hello@91cghlw.cn" className="text-primary-600 hover:text-primary-700 cursor-pointer">
                          hello@91cghlw.cn
                        </a>
                      </p>
                      <p className="text-xs text-foreground-500 mt-1">
                        <strong className="text-foreground-700">联系电话：</strong>
                        010-8888-6667
                      </p>
                    </div>
                  </div>

                  {/* Join Us */}
                  <div className="bg-background-50 rounded-2xl p-6">
                    <div className="flex items-start gap-3 mb-4">
                      <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-user-add-line text-lg text-primary-600"></i>
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-foreground-800">加入我们</h3>
                        <p className="text-xs text-foreground-400 mt-1">Join Our Team</p>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      178漫画网正在快速发展中，我们诚邀热爱漫画、认同我们理念的小伙伴加入。目前开放岗位包括前端工程师、内容运营、漫画编辑等。
                    </p>
                    <div className="mt-4 pt-4 border-t border-background-200">
                      <p className="text-xs text-foreground-500">
                        <strong className="text-foreground-700">招聘邮箱：</strong>
                        <a href="mailto:hello@91cghlw.cn" className="text-primary-600 hover:text-primary-700 cursor-pointer">
                          hello@91cghlw.cn
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Reputation / Milestones */}
          <section className="py-14 md:py-20 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="text-center mb-12">
                  <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
                    发展历程
                  </h2>
                  <p className="mt-3 text-sm text-foreground-500">
                    六年成长，每一步都离不开读者的支持
                  </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                  {[
                    {
                      year: '2020',
                      title: '梦想起航',
                      desc: '在北京成立，初始团队3人，上线第一个版本，收录漫画100部，日活用户300人。',
                    },
                    {
                      year: '2021',
                      title: '快速成长',
                      desc: '团队扩展至15人，漫画库突破500部，日活用户增长至5000人，获得天使轮融资。',
                    },
                    {
                      year: '2022',
                      title: '品类扩张',
                      desc: '上线分类浏览功能，引入下拉式阅读模式，漫画库突破1200部，月活用户突破50万。',
                    },
                    {
                      year: '2023',
                      title: '内容深耕',
                      desc: '与30+漫画工作室建立合作，推出编辑精选栏目，移动端阅读体验全面升级。',
                    },
                    {
                      year: '2024',
                      title: '生态构建',
                      desc: '日活用户突破8万，作品总数突破1500部，开设读者社区，构建完整阅读生态。',
                    },
                    {
                      year: '2025',
                      title: '品质飞跃',
                      desc: '全面升级内容审核体系，引进海外优质漫画版权，上线个性化推荐算法。',
                    },
                    {
                      year: '2026',
                      title: '全新征程',
                      desc: '日活用户突破10万大关，月阅读量超过500万次，持续为漫迷提供优质服务。',
                    },
                    {
                      year: '未来',
                      title: '永不止步',
                      desc: '我们将继续坚持免费阅读的初心，拓展更多漫画品类，为读者带来更好的阅读体验。',
                    },
                  ].map((milestone, idx) => (
                    <div key={idx} className="bg-background-100 rounded-xl p-5 hover:bg-background-200/70 transition-colors">
                      <span className="text-3xl font-heading text-accent-500">{milestone.year}</span>
                      <h3 className="text-sm font-semibold text-foreground-800 mt-2">{milestone.title}</h3>
                      <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed">{milestone.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Contact CTA */}
          <section className="py-16 md:py-24 bg-background-50">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-3xl mx-auto text-center">
                <h2 className="text-2xl md:text-5xl font-heading text-foreground-900 leading-tight">
                  商务合作
                </h2>
                <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
                  无论是漫画授权、广告合作还是品牌联名，欢迎与我们联系。我们期待与您携手共创漫画产业的美好未来。
                </p>
                <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                  <a
                    href="mailto:hello@91cghlw.cn"
                    className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer inline-flex items-center gap-2"
                  >
                    <i className="ri-mail-line"></i>
                    发送合作邮件
                  </a>
                  <Link
                    to="/"
                    className="px-8 py-3 border border-foreground-300 text-foreground-700 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-foreground-50 transition-colors cursor-pointer"
                  >
                    回到首页
                  </Link>
                </div>
                <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-sm text-foreground-500">
                  <p>
                    <i className="ri-map-pin-line mr-1 text-foreground-400"></i>
                    北京市朝阳区望京科技园B座1206
                  </p>
                  <p>
                    <i className="ri-phone-line mr-1 text-foreground-400"></i>
                    010-8888-6666
                  </p>
                  <p>
                    <i className="ri-mail-line mr-1 text-foreground-400"></i>
                    hello@91cghlw.cn
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}